module.exports = __webpack_public_path__ + "img/daniel-salaverry.486e311b.png";